/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Demotitle1Inputs */

const he_extension_demotitle1 = /** @type {(inputs: Extension_Demotitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ראה את PriceDrop בפעולה`)
};

const en_extension_demotitle1 = /** @type {(inputs: Extension_Demotitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See PriceDrop in Action`)
};

/**
* | output |
* | --- |
* | "See PriceDrop in Action" |
*
* @param {Extension_Demotitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_demotitle1 = /** @type {((inputs?: Extension_Demotitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Demotitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_demotitle1(inputs)
	return en_extension_demotitle1(inputs)
});
export { extension_demotitle1 as "extension_demoTitle" }